/* built from src/js/dw-datalayer.js - edit the source, not this file */
window.dataLayer=new Proxy(window.dataLayer||[],{set:function(n,a,e){try{e.event==="experience_impression"&&Shopify.analytics.publish("dw:dataLayerPush",{...e,eventCallback:void 0})}catch{}return n[a]=e,!0}});
